import React from "react";

import LoginPageLayer from "../components/LoginPageLayer";

const LoginPage = () => {
  return (
    <>

        {/* Login Page Layer */}
        <LoginPageLayer />

    </>
  );
};

export default LoginPage; 
